// @core/api/endpoints/chat/list_my_mention_tag_subscriptions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListMentionTagSubscriptionsResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List my mention tag subscriptions
 * Returns all mention tags the current user is subscribed to in the conversation.
 */
export async function ListMyMentionTagSubscriptions(
  conversation_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListMentionTagSubscriptionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/mention-tags/subscriptions`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.get<ListMentionTagSubscriptionsResponse>(requestPath, { ...requestOptions, params });
}
